import { get } from 'lodash';
import { Record } from 'immutable';

import {
  TestimonialQuestion,
  TestimonialResponseType,
} from '~/types/models/testimonial';
import ResponseRecord, { ResponseProps } from './Response';
import { createRecordIfNotNull } from '~/App/Records/util';

export const QuestionRecord = Record(
  {
    uuid: undefined,
    bg_color: undefined,
    question: undefined,
    question_rich: undefined,
    response_types: undefined,
    index: undefined,
    response: undefined,
  },
  'QuestionRecord'
);

interface QuestionProps extends Partial<TestimonialQuestion> {
  index?: number;
}

export default class Question extends QuestionRecord {
  public constructor(args: QuestionProps) {
    super({
      ...args,
      uuid: get(args, 'uuid'),
      bg_color: get(args, 'bg_color'),
      question: get(args, 'question'),
      question_rich: get(args, 'question_rich'),
      response_types: get(args, 'response_types'),
      index: get(args, 'index'),
      response: createRecordIfNotNull(
        get(args, 'response') as ResponseProps,
        ResponseRecord
      ),
    });
  }

  /** Get the question number */
  public getNumber(): number {
    return this.get('index') + 1;
  }

  /** Get the index of the next question */
  public getNextIndex(): number {
    return this.get('index') + 1;
  }

  /** Get the index of the previous question */
  public getPrevIndex(): number {
    return this.get('index') - 1;
  }

  /** Get the response types for the question */
  public getResponseType(): TestimonialResponseType[] {
    return (
      this.get('response_types') ?? [
        TestimonialResponseType.Video,
        TestimonialResponseType.Text,
      ]
    );
  }

  /** Get the response for the question */
  public getResponse(): ResponseRecord | null {
    return this.get('response');
  }
}
